import ProjectsView from './ProjectsView'
import { Pagination } from '../pagination/Pagination'
import { ReactElement } from 'react'
import { PagingMetadata, Project } from '@/interfaces/projects'
import { ViewModeType } from '@/interfaces/filters'

interface ProjectsViewWrapperProps {
  projects: Project[]
  viewMode: ViewModeType
  gridColumns: number
  pagingMetadata: PagingMetadata
  showCreateMessage?: boolean
}

const ProjectsViewWrapper = ({
  projects,
  viewMode,
  gridColumns,
  pagingMetadata,
  showCreateMessage
}: ProjectsViewWrapperProps): ReactElement => {
  return (
    <>
      <ProjectsView
        showCreateMessage={showCreateMessage}
        projects={projects}
        viewMode={viewMode}
        gridColumns={gridColumns}
      />
      {projects.length > 0 && pagingMetadata && (
        <Pagination pagingMetadata={pagingMetadata} sx={{ marginTop: 5, marginBottom: 8 }} />
      )}
    </>
  )
}

export default ProjectsViewWrapper
